/**
 * Прогрессбар вверху модалки
 */
function ProgressBar($container, options = {}) {
    this.options = {
        timeout: {
            progress: 100,
            remove: 500,
        }
    }

    this.progress = 0;
    this.$container = $container;

    // создаём элемент
    this.$progress = document.createElement('div');
    this.$progress.classList.add('Map__filter-map--progress');
    this.$container.appendChild(this.$progress);
    this.setProgress(0);
}

/**
 * Установка значения прогресса
 * @param {Float} progress Значение от 0 до 1
 */
ProgressBar.prototype.setProgress = function(progress) {
    this.progress = Math.min(1.0, Math.max(0.0, parseFloat(progress)));

    setTimeout(() => {
        if (!this.$progress) {
            return;
        }
        this.$progress.style.width = progress * 100 + '%';

        if (this.progress == 1.0) {
            setTimeout(() => {
                if (!this.$progress) {
                    return;
                }

                this.$progress.style.opacity = 0;
                setTimeout(this.remove.bind(this), this.options.timeout.remove);
            }, this.options.timeout.remove);
        }
    }, this.options.timeout.progress);
}

/**
 * Удаление элемента прогрессбара
 * @return {[type]} [description]
 */
ProgressBar.prototype.remove = function() {
    if (!this.$progress) {
        return;
    }

    this.$container.removeChild(this.$progress);
    this.$progress = null;
}

export default ProgressBar;
